import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonProps } from 'common/components/antd/Button/Button';
import { IconButton } from 'common/components/IconButton/IconButton';
import { ReactComponent as CloseSvg } from 'assets/ibm/close.svg';
import { ReactComponent as Svg } from 'assets/ibm/filter.svg';

type FilterButtonProps = Omit<ButtonProps, 'icon'> & {
  shown?: boolean;
};

export const FilterButton = ({ shown = false, ...restProps }: FilterButtonProps): ReactElement => {
  const { t } = useTranslation();
  return (
    <IconButton active={shown} icon={shown ? <CloseSvg /> : <Svg />} {...restProps}>
      {t('ui.button.filters')}
    </IconButton>
  );
};
